import { i18n } from '../../i18n';
import { request } from 'beans-admin-plugin';



export const filterColumnsHash = {
  city_cont: {
    label: i18n.t('contactForm.city'),
    renderCell: {
      component: 'input'
    }
  },
  email_cont: {
    label: i18n.t('contactForm.email'),
    renderCell: {
      component: 'input'
    }
  },
  name_cont: {
    label: i18n.t('contactForm.name'),
    renderCell: {
      component: 'input'
    }
  },
  country_id_eq: {
    label: i18n.t('contactForm.country'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        xRemotePreload: async () => {
          const { data } = await request.get('/countries', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/countries', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
  store_id_eq: {
    label: i18n.t('contactForm.store'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        xRemotePreload: async () => {
          const { data } = await request.get('/stores', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/stores', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('contactForm.id'),
    width: 80,
  },
  city: {
    label: i18n.t('contactForm.city'),
  },
  email: {
    label: i18n.t('contactForm.email'),
  },
  name: {
    label: i18n.t('contactForm.name'),
  },
  phone: {
    label: i18n.t('contactForm.phone'),
  },
  profession: {
    label: i18n.t('contactForm.profession'),
  },
  wechat_id: {
    label: i18n.t('contactForm.wechatId'),
  },
  country_id: {
    label: i18n.t('contactForm.country'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.country) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'countries.show', params: { id: row.country_id } }}>{row.country.name}</bean-link>
    },
  },
  store_id: {
    label: i18n.t('contactForm.store'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.store) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'stores.show', params: { id: row.store_id } }}>{row.store.name}</bean-link>
    },
  },
  user_id: {
    label: i18n.t('contactForm.user'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.user) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'users.show', params: { id: row.user_id } }}>{row.user.id}</bean-link>
    },
  },
  created_at: {
    label: i18n.t('contactForm.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('contactForm.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
}

export const formColumnsHash = {

}
